/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';

import { mediaPhone } from '../styles/breakpoints';
import { LogoLabelStyles, px, LOGO_PHONE_SCALE } from '../styles/Logo';
import { sharpImageRendering } from '../styles/images';

import LogoImage from './BfB-Logo.svg';

const LOGO_WIDTH = 120;
const LOGO_HEIGHT = 40;
const LOGO_SCALE = 0.95;

export const BFBLogoSmallOnPhone = css({
  [mediaPhone]: {
    width: px(LOGO_WIDTH * LOGO_SCALE * LOGO_PHONE_SCALE),
    height: px(LOGO_HEIGHT * LOGO_SCALE * LOGO_PHONE_SCALE),
    marginTop: '7px',
  },
});

const BFBLogo = ({ className, labelStyles, imageContainerStyles, imageStyles }) => (
  <article className={className}>
    <div className={css(LogoLabelStyles, labelStyles)}>
      Initiiert und umgesetzt von
    </div>
    <div
      className={css(`
        text-align: right;
      `, imageContainerStyles)}
    >
      <a href="http://www.bundfuerbildung.de" target="_blank" rel="noopener nofollow external">
        <img
          src={LogoImage}
          alt="Bund für Bildung"
          className={css(sharpImageRendering, {
            width: px(LOGO_WIDTH * LOGO_SCALE),
            height: px(LOGO_HEIGHT * LOGO_SCALE),
            marginTop: '2px',
          }, imageStyles)}
        />
      </a>
    </div>
  </article>
);

BFBLogo.propTypes = {
  className: PropTypes.string,
  labelStyles: PropTypes.any,
  imageContainerStyles: PropTypes.any,
  imageStyles: PropTypes.any,
};

BFBLogo.defaultProps = {
  className: undefined,
  labelStyles: undefined,
  imageContainerStyles: undefined,
  imageStyles: undefined,
};

export default BFBLogo;



// WEBPACK FOOTER //
// ./src/components/BFBLogo/BFBLogo.js